import { Button, Grid, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

export const ProjectOverviewCont = styled('div')(({ theme }) => ({
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  gap: 20,
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
}));

export const HeaderCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: COLORS.JOBS_BG,
  borderRadius: 8,
  padding: '0 20px 20px',
  marginTop: 50,
}));

export const CompanyImage = styled('img')(({ theme }) => ({
  width: 100,
  height: 100,
  objectFit: 'cover',
  borderRadius: 8,
  border: `1px solid ${COLORS.DARK_BORDER}`,
  marginTop: -65,
  padding: 5,
  backgroundColor: COLORS.WHITE,
}));

export const CompanyName = styled(CustomTypography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 500,
  color: COLORS.BLACK,
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '15px 0',
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  gap: 20,
  borderBottom: `1px solid ${COLORS.LIGHT_BORDER}`,
}));

export const ButtonCont = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: 'auto',
  gap: 20,
}));

export const Summary = styled(Grid)(({ theme }) => ({
  position: 'relative',
  marginTop: 0,
}));

export const Details = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Label = styled(CustomTypography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK_GRAY,
}));

export const PoweredButton = styled(Button)(({ theme }) => ({
  background: COLORS.WHITE,
  marginLeft: 'auto',
  width: 'fit-content',
  border: `1px solid ${COLORS.LIGHT_BORDER}`,
  borderRadius: 8,
  marginTop: 15,
}));

export const Description = styled('div')(({ theme }) => ({
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));

export const BodyCont = styled('div')(({ theme }) => ({
  padding: '10px 20px',
  display: 'flex',
  gap: 25,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const Overview = styled(CustomTypography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  marginLeft: 25,
}));

export const InfoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const ProjectRoleContainer = styled('div')(({ theme }) => ({
  padding: '0 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: 40,
  // backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));

export const MediaCont = styled('div')(({ theme }) => ({
  minWidth: 240,
  maxWidth: 240,
  gap: 10,
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: 300,
  overflowY: 'auto',
}));

export const MediaWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

export const DetailsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 25,
}));
